import adminSettingSlice from '../redux/admin/settings/adminSettingSlice';
import serviceSettingsReducer from '../redux/admin/settings/serviceSettingsSlice';
import userFilterDataReducer from '../redux/admin/settings/userFilterDataSlice';
import companyDetailReducer from '../redux/company/companyDetailSlice';

const roleBasedReducers = {
    admin: {
        adminSetting: adminSettingSlice,
        serviceSettings: serviceSettingsReducer,
        userFilterData: userFilterDataReducer,
        companyDetail: companyDetailReducer,
        // employee: employeeReducer,
    },
   
};

export default roleBasedReducers;